import { call, put, takeEvery } from '@redux-saga/core/effects';
import { SAVE_NEW_LULAV } from '../actions/actionsTypes';
import { postDataWithHeaders } from '../httpClient';
import { SaveLulavActionType } from '../actions/saveLulavAction';
import { resetUser } from '../slices/userSlice/userSlice';

export function* saveLulav(action: SaveLulavActionType): any {
  try {
    yield call(postDataWithHeaders, '/api/v1/admin/lulavs', action.headers, {
      kind: action.kind,
      price: action.price,
      active: true,
    });
    if (action.onSuccess) {
      action.onSuccess();
    }
  } catch (e: any) {
    if (e?.status === 401) {
      yield put(resetUser());
      alert('Sorry, Login Expired! Please Login again');
    } else {
      alert('Failed to save Lulav');
    }
  }
}

export function* watchSaveLulav() {
  yield takeEvery(SAVE_NEW_LULAV, saveLulav);
}
